import React from "react";
import VTSellDrink from "../page/VTSellDrink";

export default function LandingSellDrink({page}) {
    return (
        <>
            <VTSellDrink/>
        </>
    );
}